import { render, staticRenderFns } from "./SkeletonCourseInstructor.vue?vue&type=template&id=795b6d9b&scoped=true"
import script from "./SkeletonCourseInstructor.vue?vue&type=script&lang=js"
export * from "./SkeletonCourseInstructor.vue?vue&type=script&lang=js"
import style0 from "./SkeletonCourseInstructor.vue?vue&type=style&index=0&id=795b6d9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795b6d9b",
  null
  
)

export default component.exports